module.exports = __webpack_public_path__ + "img/fermentazione-vino.f79368ef.jpg";